import { Link } from "react-router-dom";
import { useT } from "../../i18n";
import SiteShell from "./SiteShell";
import HomeScreen from "./HomeScreen";

export default function LandingPage() {
  const t = useT();

  return (
    <SiteShell>
      <section className="ml-hero ml-container">
        <div className="ml-eyebrow">{t("hero.tagline")}</div>
        <h1>{t("hero.title")}</h1>
        <p>{t("hero.subtitle")}</p>
      </section>

      <section className="ml-container">
        <HomeScreen />
      </section>

      <section className="ml-container">
        <p className="ml-help-line">
          {t("support.heading")}{" "}
          <Link to="/support">
            {t("support.cta")} <span aria-hidden="true">›</span>
          </Link>
        </p>
      </section>
    </SiteShell>
  );
}
